export default "__VITE_ASSET__2cb5f9e3__"